import Experience from '../Experience.js'
import Environment from './Environment.js'
import Floor from './Floor.js'
import Fox from './Fox.js'
import Cube from './Cube.js'
import Brain from './Brain.js'
import DropNodes from './DropNodes.js'
import nodeInfo from '../nodeInfo.js'
import SpatialCursor from '../SpatialCursor.js'
import AudioManager from '../AudioManager.js'
import Logo from './Logo.js'

export default class World
{
    constructor()
    {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources

        
        //setup

        this.resources.on('ready', () => {
            console.log('resources ready')
            
            // add the floor first because it needs to be affected by the environment map
            //this.floor = new Floor()
            //this.fox = new Fox()
            
            this.cube = new Cube()

            if(this.experience.isMobile)
            {
                this.logo = new Logo()
            }
            else{
                this.brain = new Brain()
            }
            this.dropNodes = new DropNodes(nodeInfo)
            this.environment = new Environment()
            //this.audioManager = new AudioManager()
            this.spatialCursor = new SpatialCursor()
            
        })

        console.log('World initialized')
    }

    update()
    {
        if(this.fox)
        {
            this.fox.update()
        }
        if(this.cube)
        {
            this.cube.update()
        }
        if(this.brain)
        {
            this.brain.update()
        }
        if(this.dropNodes)
        {
            this.dropNodes.update()
        }
        if(this.spatialCursor)
        {
            this.spatialCursor.update()
        }
        if(this.logo)
        {
            this.logo.update()
        }
    }
}